import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemporarilyUnavailableComponent } from './temporarily-unavailable.component';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@NgModule({
  declarations: [TemporarilyUnavailableComponent],
  imports: [CommonModule, TranslatePipe, TranslateDirective],
  exports: [TemporarilyUnavailableComponent],
})
export class TemporarilyUnavailableModule {}
